import React, { useMemo } from 'react';

import {
  CssBaseline,
  ThemeProvider as MUIThemeProvider,
  createTheme,
  StyledEngineProvider,
} from '@mui/material';

import GlobalStyles from './globalStyles';
import Typography from './typography';

function ThemeProvider({ children }) {
  const themeOptions = useMemo(
    () => ({
      shape: { borderRadius: 8 },
      typography: Typography(),
      palette: {
        background: {
          default: '#FCFCFC',
        },
      },
    }),
    []
  );

  const theme = createTheme(themeOptions);

  return (
    <StyledEngineProvider injectFirst>
      <MUIThemeProvider theme={theme}>
        <CssBaseline />
        <GlobalStyles />
        {children}
      </MUIThemeProvider>
    </StyledEngineProvider>
  );
}

export default ThemeProvider;
